module.exports = __webpack_public_path__ + "img/star-rating-icon.7c41e100.svg";